import {
  IContainerTradeChart,
  ILoadDischargeChart,
  IPortcallTimeliness,
  IFreightRateIndex,
  IPartnerTradeTransit,
  ILeadTimesNew,
  ICountryTrade,
  ITradeByPartner,
  ITradePortDetailInfo,
  ITurnaround,
  IPortContainerType,
  IContainersTerminal,
  IDistributionCenter,
} from 'src/utils/typings/response';

export class TradePortDetailInfo implements IResponse<ITradePortDetailInfo> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradePortDetailInfo | undefined;
  errors?: ExpectedAny[] | undefined;
  constructor() {
    this.status_code = 200;
    this.data = undefined;
  }
}

export class ContainerTradeData implements IResponseList<IContainerTradeChart> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IContainerTradeChart[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class LoadDischargeData implements IResponseList<ILoadDischargeChart> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ILoadDischargeChart[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class TradeByPartner implements IResponseList<ITradeByPartner> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradeByPartner[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class Turnaround implements IResponseList<ITurnaround> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITurnaround[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class PortcallTimeliness implements IResponseList<IPortcallTimeliness> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IPortcallTimeliness[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class FreightRateIndex implements IResponseList<IFreightRateIndex> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IFreightRateIndex[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}
export class PortContainerType implements IResponseList<IPortContainerType> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IPortContainerType[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class PartnerTradeTransit implements IResponseList<IPartnerTradeTransit> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IPartnerTradeTransit[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}
export class ContainersTerminal implements IResponseList<IContainersTerminal> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IContainersTerminal[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class LeadTimesNew implements IResponseList<ILeadTimesNew> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ILeadTimesNew[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class CountryTrade implements IResponseList<ICountryTrade> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ICountryTrade[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class DistributionCenter implements IResponseList<IDistributionCenter> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IDistributionCenter[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}
